import { Ref } from 'preact/hooks'

import { StepSlider } from './Context'

export type StepSliderContext = {
  steps: number
  constraintRef: Ref<HTMLDivElement>
  thumbRef: Ref<HTMLDivElement>
  trackLength: number
}

interface StepSliderProviderProps extends StepSliderContext {
  children: preact.ComponentChildren
}

export function StepSliderProvider({ children, steps, constraintRef, thumbRef, trackLength }: StepSliderProviderProps) {
  const context = {
    steps,
    constraintRef,
    thumbRef,
    trackLength,
  }
  return <StepSlider.Provider value={context}>{children}</StepSlider.Provider>
}
